/*
 * Copyright    :Copyright© 2022 AOMEI
 * Abstract     :
 * Date         :2023-05-10 15:57:25
 * Author       :
 * LastEditors  :chenjia
 * LastEditTime :2025-04-22 11:04:23
 * FilePath     :\AV-COM-user-backend\src\store\app.js
 * RevisionHistory:
 */
import {
    version
} from "@/utils/util";
const state = {
    C_HEIGHT: 900,
    C_WIDTH: 1200,
    LANG: window.location.hash.slice(1) || "zh-CN",
    VERSION: version, // 国内|国外
};
const mutations = {
    SET_HEIGHT: (state, v) => {
        console.log(v);
        state.C_HEIGHT = v;
    },
    SET_WIDTH: (state, v) => {
        state.C_WIDTH = v;
    },
    SET_LANG: (state, v) => {
        state.LANG = v;
    },
};
const getters = {};
const actions = {};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};